/**
 * Auto-registers all SVG files starting with "Icon" from src/components/svg/
 * as global Vue components via vite-svg-loader + import.meta.glob.
 *
 * This restores the Vue 2 require.context behaviour that was lost during migration.
 */

const svgModules = import.meta.glob('@/components/svg/**/Icon*.svg', { eager: true })

function getComponentName (path) {
    const filename = path.split('/').pop()
    return filename.replace('.svg', '')
}

export default {
    install (app) {
        for (const [ path, module ] of Object.entries(svgModules)) {
            const name = getComponentName(path)
            const component = module.default

            if (name && component) {
                app.component(name, component)
            }
        }
    }
}
